import { length } from 'stringz';

export const CharacterCounter: React.FC<{
  text: string;
  max: number;
}> = ({ text, max }) => {
  const diff = max - length(text);

  if (diff < 0) {
    return (
      <span className='character-counter character-counter--over'>{diff}</span>
    );
  }

  let disp;
  if (diff > 1024) {
    let i = (diff / 1024).toFixed(1);
    if (i.at(-1) == "0") {
      let dot = i.indexOf('.');
      disp = i.substr(0, dot);
    } else {
      disp = i;
    }

    disp += "K";
  } else {
    disp = diff;
  }

  return <span className='character-counter'>{disp}</span>;
};
